/**
 * @generated SignedSource<<e3eede89813ea228632632f9bd0b0aa4>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApplyAccessKeyInput = {|
  access_key: string,
  clientMutationId?: ?string,
  validated_email_token: string,
|};
export type AuthContextApplyAccessKeyMutation$variables = {|
  input: ApplyAccessKeyInput,
|};
export type AuthContextApplyAccessKeyMutation$data = {|
  +apply_access_key: {|
    +target_url: ?({|
      +__typename: "AccessKeyConsumed",
      +message: string,
    |} | {|
      +__typename: "InactiveAccessKey",
      +message: string,
    |} | {|
      +__typename: "InvalidAccessKey",
      +message: string,
    |} | {|
      +__typename: "StringWrapper",
      +value: string,
    |} | {|
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      +__typename: "%other",
    |}),
  |},
|};
export type AuthContextApplyAccessKeyMutation = {|
  response: AuthContextApplyAccessKeyMutation$data,
  variables: AuthContextApplyAccessKeyMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ApplyAccessKeyPayload",
    "kind": "LinkedField",
    "name": "apply_access_key",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "target_url",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "StringWrapper",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "InactiveAccessKey",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "InvalidAccessKey",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "AccessKeyConsumed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthContextApplyAccessKeyMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthContextApplyAccessKeyMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5d05e2de42f991028b2ca52de8a77eab",
    "id": null,
    "metadata": {},
    "name": "AuthContextApplyAccessKeyMutation",
    "operationKind": "mutation",
    "text": "mutation AuthContextApplyAccessKeyMutation(\n  $input: ApplyAccessKeyInput!\n) {\n  apply_access_key(input: $input) {\n    target_url {\n      __typename\n      ... on StringWrapper {\n        value\n      }\n      ... on InactiveAccessKey {\n        message\n      }\n      ... on InvalidAccessKey {\n        message\n      }\n      ... on AccessKeyConsumed {\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "989cc27cac0822982a0d9883ebdf0393";

module.exports = ((node/*: any*/)/*: Mutation<
  AuthContextApplyAccessKeyMutation$variables,
  AuthContextApplyAccessKeyMutation$data,
>*/);
